<template>
  <div class="hello">
    <full-page :options="options" ref="fullpage">
      <div class="section page1">
        <PageHeader isActive="home"></PageHeader>
        <div class="page-banner">
          <el-carousel height="100vh" arrow="never" :autoplay="true">
            <el-carousel-item>
              <div class="page-bj">
                <img style="width: 100%; height: 100%" :src="info.banner" alt="" />
              </div>
            </el-carousel-item>

            <el-carousel-item>
              <div class="page-bj">
                <img style="width: 100%; height: 100%" :src="info.banner1" alt="" />
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="page-bj">
                <img style="width: 100%; height: 100%" :src="info.banner2" alt="" />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="section page2 page-bj">
        <div class="item-page">
          <img
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/gsjjtext-bj.png"
            class="gsjjbj"
            alt=""
          />
          <div class="item-title">公司简介</div>
          <div class="item-line"></div>

          <div class="gsjj-con">
            <div class="gsjj-text">
              <!-- <img src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/douhaoshang.png" alt="" class="douhao"> -->
              <div class="js-text">
                <img
                  class="leftpoint"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/douhaoshang.png"
                  alt=""
                />
                <span style=" text-indent:2em;" v-for="(item,index) in info.content1" :key="index">{{item}}</span>
                <img
                  class="rightpoint"
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/douhaoxia.png"
                  alt=""
                />
              </div>
              <!-- <img src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/douhaoxia.png" alt="" class="douhao"> -->
            </div>
          </div>
        </div>
      </div>

      <div class="section page2-bj">
        <div class="item-page">
          <img
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Product  display@2x.png"
            class="gsjjbj"
            alt=""
          />
          <div class="item-title">产品展示</div>
          <div class="item-line"></div>

          <div class="cpzs-con">
            <ul class="row">
              <li>
                <div @click="toNewsInformation">
                  <div class="tip"><span>就业创业服务云平台</span></div>
                  <div class="shadow">
                    <p>就业创业服务云平台</p>
                    <span
                      >优化人才、劳动、信息、知识、技术、管理、资本、服务、数据“众创”平台、“共享”服务</span
                    >
                  </div>
                  <!-- <img
                    src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/s_1.png"
                    alt=""
                  /> -->
                </div>
              </li>
              <li>
                <div @click="toEntrepreneurshipTraining">
                  <div class="tip"><span>网络创业实训平台</span></div>
                  <div class="shadow">
                    <p>网络创业实训平台</p>
                    <span
                      >优化人才、劳动、信息、知识、技术、管理、资本、服务、数据“众创”平台、“共享”服务</span
                    >
                  </div>
                  <!-- <img
                    src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/s_2.png"
                    alt=""
                  /> -->
                </div>
              </li>
              <li>
                <div @click="toNetworkSimulation">
                  <div class="tip"><span>网络模拟实训平台</span></div>
                  <div class="shadow">
                    <p>网络模拟实训平台</p>
                    <span
                      >优化人才、劳动、信息、知识、技术、管理、资本、服务、数据“众创”平台、“共享”服务</span
                    >
                  </div>
                  <!-- <img
                    src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/s_3.png"
                    alt=""
                  /> -->
                </div>
              </li>
              <li>
                <div @click="toEmploymentTraining">
                  <div class="tip"><span>就业实训平台</span></div>
                  <div class="shadow">
                    <p>就业实训平台</p>
                    <span
                      >优化人才、劳动、信息、知识、技术、管理、资本、服务、数据“众创”平台、“共享”服务</span
                    >
                  </div>
                  <!-- <img
                    src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/s_4.png"
                    alt=""
                  /> -->
                </div>
              </li>
            </ul>
          </div>
          <button @click="getmore" class="more-btn">更多</button>
        </div>
      </div>

      <div class="section page2 page-bj">
        <div class="item-page">
          <img
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/News  information@2x.png"
            class="gsjjbj"
            alt=""
          />
          <div class="item-title">行业动态</div>
          <div class="item-line"></div>

          <div class="xwzx-con">
            <div class="xwzx-box">
              <div class="topbox">
                <div class="topxwzx">
                  <img :src="indeximgList[0].coverImg" alt="" />
                </div>
                <div class="topxwzx">
                  <span class="titletxt">{{ indeximgList[0].title }}</span>
                  <p class="cypxtxt">
                    {{ indeximgList[0].baseDesc }}
                  </p>
                  <a
                    href="#"
                    @click="toDetails(indeximgList[0].id)"
                    class="getmore"
                  ></a>
                </div>
                <div class="topxwzx">
                  <img :src="indeximgList[1].coverImg" alt="" />
                </div>
                <div class="topxwzx">
                  <span class="titletxt">{{ indeximgList[1].title }}</span>
                  <p class="cypxtxt">
                    {{ indeximgList[1].baseDesc }}
                  </p>
                  <a
                    href="#"
                    @click="toDetails(indeximgList[1].id)"
                    class="getmore"
                  ></a>
                </div>
              </div>

              <div class="underbox">
                <div class="topxwzx">
                  <span class="titletxt">{{ indeximgList[2].title }}</span>
                  <p class="cypxtxt">
                    {{ indeximgList[2].baseDesc }}
                  </p>
                  <a
                    href="#"
                    @click="toDetails(indeximgList[2].id)"
                    class="getmore"
                  ></a>
                </div>
                <div class="topxwzx">
                  <img :src="indeximgList[2].coverImg" alt="" />
                </div>
                <div class="topxwzx">
                  <span class="titletxt">{{ indeximgList[3].title }}</span>
                  <p class="cypxtxt">
                    {{ indeximgList[3].baseDesc }}
                  </p>
                  <a
                    href="#"
                    @click="toDetails(indeximgList[3].id)"
                    class="getmore"
                  ></a>
                </div>
                <div class="topxwzx">
                  <img :src="indeximgList[3].coverImg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section page2 page-bj container-fluid">
        <div class="item-page">
          <img
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Service  cooperation@2x.png"
            class="gsjjbj"
            alt=""
          />
          <div class="item-title">服务合作</div>
          <div class="item-line"></div>
          <h5>
            组建创新联合体，拓展产学研用联合通道，实施好关键技术攻关，深入谋划“科技创新”项目，<br />运用政府引领市场化运营机制，加强人力资源综合服务水平，纵深推进大众创业万众创新。
          </h5>
          <div class="fwhz-con row">
            <div
              class="pic-one"
              :class="{ active: activeNum === 1 }"
              @mouseover="hoverOne"
              @mouseleave="mouseLeave"
            >
              <div v-if="activeNum === 1" class="mask">
                <div>
                  <img
                    src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/矢量智能对象@2x(4).png"
                    alt=""
                  /><span>创业培训</span>
                </div>
                <b></b
                ><span
                  >基于“一测四训”五个平台，打造完善的创业培训闭环。精准定位创业项目，玩转创业实训，掌握创业方法，以训代学，本着“实践出真知”的原则，告别枯燥无味的理论学习，对创业培训做到仿真模拟、真听、真看、真体验。</span
                >
              </div>
              <div v-else class="under-body">
                <img
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/矢量智能对象@2x(4).png"
                  alt=""
                />一<span
                  >创 <br />
                  业<br />培<br />训</span
                >
              </div>
            </div>

            <div
              class="pic-two"
              :class="{ active: activeNum === 2 }"
              @mouseover="hoverTwo"
              @mouseleave="mouseLeave"
            >
              <div v-if="activeNum === 2" class="mask">
                <div>
                  <img
                    src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/矢量智能对象@2x(6).png"
                    alt=""
                  /><span>项目孵化</span>
                </div>
                <b></b
                ><span
                  >贯彻“就业优先，聚力增效”政策精神，积极推进线上线下更广更深融合发展创业就业服务新业态新模式，以创新就业创业测评和慕课在线学习为基础、以创业模拟实训、网络创业培训为依托，以辅导实践孵化为主体，以项目孵化为主线，以创业就业数据和成果转化为目标，以“创业带动就业，实现拓宽市场化的就业渠道”，构建集创业培训实践、创业综合服务、创业人才储备、项目成果转化、产业植入五位一体的创业服务体系。
                </span>
              </div>
              <div v-else class="under-body">
                <img
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/矢量智能对象@2x(6).png"
                  alt=""
                />一<span
                  >项 <br />
                  目<br />孵<br />化</span
                >
              </div>
            </div>
            <div
              class="pic-three"
              :class="{ active: activeNum === 3 }"
              @mouseover="hoverThree"
              @mouseleave="mouseLeave"
            >
              <div v-if="activeNum === 3" class="mask">
                <div>
                  <img
                    src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/矢量智能对象@2x(5).png"
                    alt=""
                  /><span>数据跟踪</span>
                </div>
                <b></b
                ><span>
                  将培训数据进行长久保存，并采用特别算法对数据进行分析，挖掘出数据深层其含义，对今后的创就业培训发展指明方向
                </span>
              </div>
              <div v-else class="under-body">
                <img
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/矢量智能对象@2x(5).png"
                  alt=""
                />一<span>数<br />据<br />跟<br />踪</span>
              </div>
            </div>
            <div
              class="pic-four"
              :class="{ active: activeNum === 4 }"
              @mouseover="hoverFour"
              @mouseleave="mouseLeave"
            >
              <div v-if="activeNum === 4" class="mask">
                <div>
                  <img
                    src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/矢量智能对象@2x(3).png"
                    alt=""
                  /><span>启创港</span>
                </div>
                <b></b
                ><span>
                  启创创业服务港依托人工智能、物联网、大数据、云计算等技术，以提供“就业创业综合人力资源服务”为目标，利用线上与线下相结合的方式，为各类就业创业者提供“精准化指导、个性化培育”人力资源服务一体化解决方案。
                  采用“就业创业培训+人力资源服务”的方式，依据国家相关政策，结合不同的服务需求，利用“一测四训”的服务模式，打造“高质量就业、高成功功率创业”的综合性服务体系。</span
                >
              </div>
              <div v-else class="under-body">
                <img
                  src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/矢量智能对象@2x(3).png"
                  alt=""
                />一<span>启<br />创<br />港<br />&nbsp;</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section page2 page-bj container-fluid">
        <div class="item-page">
          <img
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/Customer  case@2x.png"
            class="gsjjbj"
            alt=""
          />
          <div class="item-title">客户案例</div>
          <div class="item-line"></div>
          <div class="khal-con">
            <div class="khalbgi">
              <div @click="goleft" class="goleft"></div>
              <div @click="goright" class="goright"></div>
              <img
                class="left-ion"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/yinghao2.png"
                alt=""
              />
              <img
                class="right-ion"
                src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/yinghao.png"
                alt=""
              />
              <div class="khal-text">
                东云启创总共为超过<span>100</span>家院校机构客户和<span>20</span>余个政府机构提供智能服务，每天产生的数据调用次数超过<span>10</span>万次。
              </div>
            </div>
          </div>
          <el-carousel
            ref="showpage"
            indicator-position="none"
            arrow="never"
            class="loop"
            trigger="click"
            :interval="10000"
          >
            <el-carousel-item
              class="under-box"
              v-for="item in imgList"
              :key="item"
            >
              <ul class="school-box">
                <li v-for="(i, index) in item" :key="index" @click="handleImg(i.superLinks)">
                  <img :src="i.coverImg" alt="" />
                </li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="section mine page2">
        <div class="end-con">
          <img
            class="end-img1"
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/index/text1.png"
            alt=""
          />
          <img
            class="end-img2"
            src="https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/index/text2.png"
            alt=""
          />
        </div>
        <div class="box">
          <PageFooter class="footer"></PageFooter>
        </div>
      </div>
    </full-page>
  </div>
</template>

<script>
import "../assets/css/fullpage.css";
import PageFooter from "@/components/footer";
import PageHeader from "@/components/header";
import { getAllproject, getindeximg, getHome } from "@/api/index.js";
export default {
  name: "index",
  components: {
    PageFooter,
    PageHeader,
  },
  data() {
    return {
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true,
        navigationPosition: "right",
        resize: true,
        scrollingSpeed: 700,
        recordHistory: true,
        loopBottom: true,
        // loopTop: true,
        //为每个section设置背景色
      },
      activeNum: 0,
      imgList: [], //图片轮播列表
      indeximgList: [],
      info: {},
    };
  },
  mounted() {
    this.getAllproject();
    this.getindeximg();
    getHome().then((res) => {
      console.log(res);
      if (res.status == 200) {
        this.info = res.data;
        this.info.content1 = this.info.content1.split('；')
      }
    });
  },
  methods: {
    getHomeDetails() {},
    toDetails(index) {
      // console.log(index)
      this.$router.push({
        path: `/Informationdetails`,
        query: { id: index },
      });
    },
    async getindeximg() {
      const res = await getindeximg();
      this.indeximgList = res.data;
      console.log("主页", this.indeximgList);
    },
    async getAllproject() {
      const res = await getAllproject();
      this.imgList = res.data;
      console.log(res.data);
    },
    toNewsInformation() {
      this.$router.push("/NewsInformation");
    },
    toEntrepreneurshipTraining() {
      this.$router.push("/EntrepreneurshipTraining");
    },
    toNetworkSimulation() {
      this.$router.push("/NetworkSimulation");
    },
    toEmploymentTraining() {
      this.$router.push("/EmploymentTraining");
    },
    hoverOne() {
      //  console.log(this.activeNum)
      this.activeNum = 1;
      console.log(this.activeNum);
    },
    hoverTwo() {
      this.activeNum = 2;
      console.log(this.activeNum);
    },
    hoverThree() {
      //  console.log(this.activeNum)
      this.activeNum = 3;
      console.log(this.activeNum);
    },
    hoverFour() {
      //  console.log(this.activeNum)
      this.activeNum = 4;
      console.log(this.activeNum);
    },
    mouseLeave() {
      this.activeNum = 0;
    },
    goleft() {
      this.$refs.showpage.prev();
      console.log(1);
    },
    goright() {
      this.$refs.showpage.next();
      console.log(2);
    },
    getmore() {
      this.$router.push("/ProductCenter");
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//  * {
//   //  line-height: 0;
//  }
.box {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.mine {
  position: relative;
}
.el-carousel__mask {
  height: 311px;
}
.end-con {
  padding-top: 2%;
  position: relative;
  margin: 0 auto;
  // width: 1718px;
  height: 100%;
  // height: 70vh;
  background-size: cover;
  background-position: -300px, -269px;
  background-repeat: no-repeat;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/index/endbgi.png");
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  .end-img1 {
    width: 22%;
  }
  .end-img2 {
    width: 70%;
  }
  img {
    margin-top: 4%;
  }
}
.goleft {
  position: absolute;
  top: 200px;
  left: 60px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/goleft.png");
  width: 22px;
  height: 41px;
  background-size: cover;
  background-repeat: no-repeat;
}
.goright {
  position: absolute;
  top: 200px;
  right: 60px;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/goright.png");
  width: 22px;
  height: 41px;
  background-size: cover;
  background-repeat: no-repeat;
}
.left-ion {
  position: absolute;
  top: 15%;
  left: 12%;
  width: 3%;
}
.right-ion {
  width: 3%;
  position: absolute;

  top: 33%;
  right: 12%;
}
.khal-text {
  width: 871px;
  height: 84px;
  margin: 0 auto;
  // margin-top: 138px;
  // background-color: #cccc;
  font-size: 20px;
  font-family: Microsoft Yahei;
  font-weight: 400;
  color: #ffffff;
  line-height: 52px;
  opacity: 0.9;
  span {
    font-family: Microsoft Yahei;
    font-size: 40px;
    color: #f4930f;
  }
}
.school-box {
  padding: 0;
  width: 100%;
  height: 80%;
  position: absolute;
  bottom: 0;
  li {
    height: 51%;
    width: 16.66%;
    z-index: 999;
    background: #ffffff;
    list-style: none;
    float: left;
    border: 1px solid #dddddd;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    img {
      width: 76%;
    }
  }
}
.khal-con {
  // padding-top: 7%;
  position: relative;
  // margin-top: 19%pbt;
  // top: 0;
  // margin-top: 70%;
  // left: 50%;
  // transform: translateX(-50%);
  // bottom: 0;
  margin: 0 auto;
  width: 89.95%;
  height: 68.5%;
  overflow: hidden;
  // width: 100%;
  // height: 70vh;
  background-size: cover;
  background-position: 0 -30px;
  background-repeat: no-repeat;
  .khalbgi {
    padding-top: 7%;
    height: 100%;
    background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/组 24.png");
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
    position: relative;
  }
}
.loop {
  transform: translateX(5.6%);
  //  transform: translateY();
  margin: 0 auto;
  // height: 32%;
  z-index: 99;
  width: 90%;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  left: 0;
  // margin-bottom: 1%;
  // display: flex;
  // justify-content: center;
  // height: 340px;
  // background-color: red;
  .under-box {
    width: 100%;
    // height: 100%;
  }
}
.mask {
  width: 100%;
  height: 100%;
  // z-index: 1;
  background: linear-gradient(149deg, #00aeff, #1c43bd);
  opacity: 0.85;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  // transition: 0.5s;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    transition: 0.5s;
    span {
      font-size: 28px;
      font-family: Microsoft Yahei;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      // transition: 0.5s;
    }
    img {
      position: relative;
      transition: 0.5s;
      left: 170px;
      top: -4px;
      width: 50px;

      // margin-right: 30px;
    }
  }
  b {
    width: 50px;
    border-bottom: 3px solid #fff;
    margin-bottom: 30px;
    margin-top: 30px;
    transition: 0.5s;
  }
  span {
    // transition: 0.5s;
    font-size: 20px;
    font-family: Microsoft Yahei;
    font-weight: 400;
    color: #ffffff;
    width: 516px;
    text-align: left;
  }
}
.fwhz-con {
  margin-top: 2%;
  width: 100%;
  // height: 69vh;
  height: 61%;
  display: flex;
  justify-content: center;

  div > div {
    // height: 100%;
    // background-color: red;
    background-size: cover;
    // background-position: center;
    background-repeat: no-repeat;
  }
  .pic-one {
    width: 20%;
    height: 100%;
    background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/index-img/img1.png");
    background-size: cover;
    overflow: hidden;
    transition: 0.5s;
  }
  .pic-one.active {
    transition: 0.5s;
    width: 40%;
  }
  .pic-two {
    width: 20%;
    height: 100%;
    background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/index-img/img2.png");
    background-size: cover;
    transition: 0.5s;
    overflow: hidden;
  }
  .pic-two.active {
    width: 40%;
    transition: 0.5s;
  }
  .pic-three {
    width: 20%;
    height: 100%;
    background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/index-img/img3.png");
    background-size: cover;
    transition: 0.5s;
    overflow: hidden;
  }
  .pic-three.active {
    width: 40%;
    transition: 0.5s;
  }
  .pic-four {
    width: 20%;
    height: 100%;
    background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/index-img/img4.png");
    background-size: cover;
    transition: 0.5s;
    overflow: hidden;
  }
  .pic-four.active {
    width: 40%;
    transition: 0.5s;
  }
  .under-body {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 36px;
    color: #fff;
    font-weight: 400;
    line-height: 1;
    span {
      font-size: 26px;
    }

    img {
      width: 50px;
      margin-bottom: 10px;
    }
  }
}

.xwzx-con {
  width: 100%;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/page4bgi.png");
  background-size: cover;
  background-position: center;
  /* height: 40vw; */
  background-repeat: no-repeat;
  // height: 600px;
  display: flex;
  padding-top: 2%;
  height: 70%;
  padding-bottom: 3%;

  justify-content: center;
  align-items: center;
  .xwzx-box {
    // background: linear-gradient(146deg, #1C43BD, #00AEFF);
    border: 15px solid;
    border-image: linear-gradient(to top, #0041a6, #003e817e) 1 10;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    height: 100%;
    box-sizing: border-box;
    // width: 1710px;
    .topbox {
      height: 50%;
      display: flex;
    }
    .underbox {
      height: 50%;
      display: flex;
    }
    .topbox > div:nth-child(odd) {
      //  width: 420px;
      // background-repeat: no-repeat;
      // background-size: cover;
      overflow: hidden !important;
      padding: 0 !important;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        // scale: 1;
        // transform: scale(1.1);
      }
    }

    .topbox > div {
      position: relative;
      width: 25%;
      height: 100%;
      text-align: left;
      font-family: Microsoft Yahei;
      font-weight: 400;
      color: #ffffff;
      font-size: 26px;
      padding: 1%;
      padding-left: 1%;
      // padding-top: 0;
      // padding-bottom: 0;
      // border: 1px solid transparent;
      overflow: hidden !important;
      // border: 1px solid #000;
      box-sizing: border-box;
      span {
        display: block;
        width: 100%;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
      p {
        font-size: 16px;
        font-family: Microsoft Yahei;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.8;
        line-height: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .getmore {
        margin-top: 5%;
        display: block;
        background-size: cover;
        background-repeat: no-repeat;
        width: 43px;
        height: 16px;
        background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/getmore.png");
      }
    }
    .topbox > div:nth-child(odd):hover {
      img {
        transform: scale(1.1, 1.1);
        transition: 0.8s;
      }
    }

    .underbox > div:nth-child(even) {
      // background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/图层 38@2x.png");
      //  width: 420px;
      // background-repeat: no-repeat;
      // background-size: cover;
      padding: 0 !important;
      img {
        width: 100%;
        // transform: scale(1.1);
        height: 100%;
      }
    }
    .underbox > div:nth-child(even):hover {
      img {
        transform: scale(1.1, 1.1);
        transition: 0.8s;
      }
    }
    .underbox div {
      float: left;
      width: 25%;
      height: 100%;
      text-align: left;
      font-family: Microsoft Yahei;
      font-weight: 400;
      color: #ffffff;
      font-size: 26px;
      padding: 1%;
      // padding-left: 1%
      // padding-right: 1%;
      overflow: hidden;
      box-sizing: border-box;
      span {
        display: block;
        width: 100%;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
      p {
        font-size: 16px;
        font-family: Microsoft Yahei;
        font-weight: 400;
        color: #ffffff;
        opacity: 0.8;
        line-height: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
      .getmore {
        margin-top: 5%;
        display: block;
        background-size: cover;
        background-repeat: no-repeat;
        width: 43px;
        height: 16px;
        background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/getmore.png");
      }
    }
  }
}
.page2-bj {
  // height: 100vh;
  position: relative;
  width: 100%;
  background-size: cover;
  background-position: start;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/组 22.png");
}

.more-btn {
  width: 10%;
  height: 55px;
  border: 1px solid #033f9a;
  background: transparent;
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  font-family: Microsoft Yahei;
  font-weight: 400;
  margin-top: 1%;
}
.more-btn:hover {
  border: 1px solid #033f9a;
  background: linear-gradient(146deg, #1c43bd, #00aeff);
  border-radius: 5px;
  color: #fff;
  font-size: 16px;
  font-family: Microsoft Yahei;
  font-weight: 400;
}
//  *{
//    padding: 0;
//    margin: 0;
//  }
.col-xs-1,
.col-sm-1,
.col-md-1,
.col-lg-1,
.col-xs-2,
.col-sm-2,
.col-md-2,
.col-lg-2,
.col-xs-3,
.col-sm-3,
.col-md-3,
.col-lg-3,
.col-xs-4,
.col-sm-4,
.col-md-4,
.col-lg-4,
.col-xs-5,
.col-sm-5,
.col-md-5,
.col-lg-5,
.col-xs-6,
.col-sm-6,
.col-md-6,
.col-lg-6,
.col-xs-7,
.col-sm-7,
.col-md-7,
.col-lg-7,
.col-xs-8,
.col-sm-8,
.col-md-8,
.col-lg-8,
.col-xs-9,
.col-sm-9,
.col-md-9,
.col-lg-9,
.col-xs-10,
.col-sm-10,
.col-md-10,
.col-lg-10,
.col-xs-11,
.col-sm-11,
.col-md-11,
.col-lg-11,
.col-xs-12,
.col-sm-12,
.col-md-12,
.col-lg-12,
.container-fluid,
.container {
  padding-right: 0;
  padding-left: 0;
}

.row {
  margin-right: 0;
  margin-left: 0;
}

// .footer {

// }
.leftpoint {
  position: relative;
  left: -10%;
  top: 1%;
  width: 8%;
}
.rightpoint {
  position: relative;
  right: -97%;
  bottom: 1%;
  width: 8%;
}
.item-page {
  /* padding-top: 100px; */
  text-align: center;
  height: 100%;
  position: relative;
  overflow: hidden;
  /* justify-content: center;
   display: flex;
  flex-direction: column; */
  h5 {
    margin: 0 auto;
    margin-top: -1%;
    // width: 1%;
    // height: 47px;
    font-size: 16px;
    font-family: Microsoft Yahei;
    font-weight: 400;
    color: #ffffff;
    line-height: 31px;
  }
}
.item-title {
  font-size: 50px;
  font-family: Microsoft Yahei;
  font-weight: 400;
  color: #ffffff;
  margin-top: -28px;
}
.zzydksj {
  text-align: center;
}
.douhao {
  width: 50px;
  margin-right: auto;
}
.gsjj-con {
  width: 100%;
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/gongsijieshao.jpg");
  background-size: cover;
  background-position: center;
  /* height: 40vw; */
  background-repeat: no-repeat;
  height: 70%;
  // height: 600px;
}
.cpzs-con {
  width: 100%;
  overflow: auto;
  height: 55%;
  overflow: hidden;

  // text-align: center;
  display: flex;
  justify-content: center;
  ul {
    display: flex;
    justify-content: center;
    width: 100%;

    li {
      height: 100%;
      // border: 4px solid #000;
      position: relative;
      margin-right: 3%;
      list-style: none;
      float: left;
      width: 20%;
      // background-color: #fff;
      // height: 539px;
      overflow: hidden;
      .shadow {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 0px;
        background: linear-gradient(149deg, #00aeff, #1c43bd);
        opacity: 0.85;
        transition: 0.8s;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        p {
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #ffffff;
          line-height: 29px;
          display: none;
        }
        span {
          width: 70%;
          display: none;
          font-size: 16px;
          font-family: Microsoft Yahei;
          font-weight: 400;
          color: #ffffff;
          line-height: 29px;
          transition: 0.8s;
          text-align: left;
        }
      }

      .tip {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 68px;
        background: #1f47c94d;
        // opacity: 0.25;
        transition: 2.5s;
        span {
          font-size: 22px;
          font-family: Microsoft Yahei;
          font-weight: 400;
          color: #ffffff;
          line-height: 68px;

          // opacity: 1;
        }
      }
    }
    li:nth-child(1) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/s_1.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    li:nth-child(2) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/s_2.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    li:nth-child(3) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/s_3.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    li:nth-child(4) {
      background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/s_4.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    li:hover {
      .shadow {
        height: 100%;
        transition: 0.8s;
        p {
          display: block;
        }
        span {
          display: block;
          transition: 0.8s;
        }
      }
      .tip {
        // margin-bottom: 160%;
        // height: 0px;
        opacity: 0;
        // display: none;
        transition: 0.5s;
      }
    }
  }

  // background-image: url('https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/gongsijieshao.jpg');
  // background-size: cover;
  // background-position: center;
  // /* height: 40vw; */
  // background-repeat: no-repeat;
  // height: 66vh;
}
.gsjjbj {
  height: 6%;
  margin: 0 auto;
  margin-top: 5.5%;
}
.zzy-1 {
  margin: 0 auto;
  width: 36%;
  height: auto;
  display: block;
}
/* .gsjj-bj {

} */
.zzy-2 {
  display: block;
  margin-top: 50px;
  margin: 0 auto;
  width: 38%;
  height: auto;
}
.page2 {
  background-image: url("https://dyqc.oss-accelerate.aliyuncs.com/qcwl/base/img/page2-bj.png");
}
/* .item-page { */
/* display: flex;
  flex-direction: column;
  align-items: center; */
/* } */
.item-line {
  width: 120px;
  height: 4px;
  background: #f39a21;
  margin: 0 auto;
  margin-top: 2%;
  margin-bottom: 4%;
}
.page-banner {
  width: 100%;
  height: 100vh;
}
.page-bj {
  width: 100%;
  height: 100%;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.gsjj-text {
  width: 50%;
  background: rgba(28, 67, 189, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.js-text {
  width: 75%;
  font-size: 16px;
  font-family: Microsoft Yahei;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  text-align: left;
  // height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
@media only screen and (max-width: 1440px) {
  .titletxt {
    font-size: 18px;
  }
  .cypxtxt {
    font-size: 14px !important;
  }
  .item-line {
    margin-top: 1%;
    margin-bottom: 2%;
  }
}
@media only screen and (max-width: 1200px) {
  // .end-img1 {
  //   width: 60%;
  // }
  .titletxt {
    font-size: 18px;
  }
  .cypxtxt {
    font-size: 12px;
  }
  .more-btn {
    // width: 11%;
    height: 40px;
    font-size: 12px;
    margin-top: 10px;
  }
  .zzy-1 {
    width: 60%;
  }
  .zzy-2 {
    width: 90%;
  }
  .item-title {
    font-size: 30px;
  }
  .item-line {
    width: 80px;
  }
  .gsjj-con {
    /* height: 50vw; */
    background-size: cover;
  }
  .gsjj-text {
    width: 100%;
  }
}

@media only screen and (max-width: 800px) {
  .gsjj-con {
    /* height: 80%; */
    background-size: cover;
  }
}
@media only screen and (max-width: 400px) {
  .gsjj-con {
    /* height: 90vw; */
    background-size: cover;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue